import { fetchUserReviews } from 'actions/ReviewActions'
import type { FetchReviewsParams } from 'api/review'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { fillArray } from 'lib/array/arrayUtils'
import getObjectKey from 'lib/object/getObjectKey'
import { useEffect, useMemo } from 'react'

type ReturnType = [
  {
    reviews: Array<App.Review>
    total: number
  } | undefined,
  boolean,
  any | undefined,
]

function useUserReviews(params: FetchReviewsParams): ReturnType {
  const dispatch = useAppDispatch()
  const { limit = 4, offset = 0, ...keyParams } = params
  const key = getObjectKey(keyParams)
  const reviewRecord = useAppSelector((state) => state.review.reviews[key])

  useEffect(() => {
    dispatch(fetchUserReviews(params))
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, key, limit, offset])

  const returnRecord = useMemo(() => {
    if (!reviewRecord) return undefined

    const positionsRequired = new Set(fillArray(limit).map((_, index) => (index + 1) + offset))
    const positionReviews = reviewRecord.reviews.filter(record => positionsRequired.has(record.position))
    return {
      reviews: positionReviews.map(record => record.review),
      total: reviewRecord.total,
    }
  }, [reviewRecord, limit, offset])

  return [
    returnRecord,
    reviewRecord?.fetching ?? true,
    reviewRecord?.error,
  ]
}

export default useUserReviews
